export default "__VITE_ASSET__C_YNZp5g__"